var _path, _rect, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlankFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 94,
    viewBox: "0 0 123 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99976 93.9437H112.648C118.171 93.9437 122.648 89.4665 122.648 83.9437V16.7485C122.648 11.2257 118.171 6.74851 112.648 6.74851H62.1456C59.7584 6.74851 57.5578 5.45779 56.3927 3.37425C55.2276 1.29072 53.027 0 50.6398 0H9.99976C4.47691 0 -0.000244141 4.47716 -0.000244141 10V83.9437C-0.000244141 89.4665 4.47691 93.9437 9.99976 93.9437Z",
    fill: "#214C7B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.21875,
    y: 10.1482,
    width: 109.601,
    height: 79.1562,
    rx: 10,
    fill: "black",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.37891,
    y: 11.5979,
    width: 109.601,
    height: 79.1562,
    rx: 10,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.649 93.9436H10C4.47715 93.9436 0 89.4665 0 83.9436V35.0646C0 29.5418 4.47716 25.0646 10 25.0646H59.9229C62.7601 25.0646 65.33 23.3908 66.477 20.7959C67.6241 18.2009 70.194 16.5271 73.0311 16.5271H112.649C118.172 16.5271 122.649 21.0043 122.649 26.5271V83.9436C122.649 89.4665 118.172 93.9436 112.649 93.9436Z",
    fill: "#2D6CB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankFill);
export default __webpack_public_path__ + "static/media/blankFill.987ac803ca6d6f2b5bcd7881d6fc20b1.svg";
export { ForwardRef as ReactComponent };